/* Delivery price checker: matches a UK postcode to a price from theme settings. */
(function () {
  var dialog = document.getElementById('UvbDeliveryChecker');
  if (!dialog) return;

  function readJson(selector) {
    var el = dialog.querySelector(selector);
    try { return JSON.parse(el.textContent) || ''; } catch (e) { return ''; }
  }

  // "40: DN\n70: S, LS" -> { DN: 40, S: 70, LS: 70 }
  var prices = {};
  readJson('[data-uvb-dc-zones]').split(/\n+/).forEach(function (line) {
    var parts = line.split(':');
    if (parts.length < 2) return;
    var price = parseFloat(parts[0].replace(/[^0-9.]/g, ''));
    if (isNaN(price)) return;
    parts.slice(1).join(':').split(',').forEach(function (area) {
      area = area.trim().toUpperCase();
      if (area) prices[area] = price;
    });
  });

  // "IV41-49, PA20" -> [{area:'IV', from:41, to:49}, {area:'PA', from:20, to:20}]
  var quote = [];
  readJson('[data-uvb-dc-quote]').split(/[,\n]+/).forEach(function (item) {
    var m = item.trim().toUpperCase().match(/^([A-Z]{1,2})(\d{1,2})(?:\s*-\s*(?:[A-Z]{1,2})?(\d{1,2}))?$/);
    if (!m) return;
    quote.push({ area: m[1], from: Number(m[2]), to: Number(m[3] || m[2]) });
  });

  var form = dialog.querySelector('[data-uvb-dc-form]');
  var input = dialog.querySelector('#UvbDeliveryPostcode');
  var result = dialog.querySelector('[data-uvb-dc-result]');
  var main = dialog.querySelector('[data-uvb-dc-main]');
  var mini = dialog.querySelector('[data-uvb-dc-mini]');
  var contact = dialog.querySelector('[data-uvb-dc-contact]');
  var currency = dialog.dataset.currency || '£';
  var lastTrigger = null;

  function formatPrice(value) {
    var fixed = value % 1 === 0 ? String(value) : value.toFixed(2);
    return currency + fixed;
  }

  function parse(raw) {
    var pc = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    var outward = pc.length >= 5 ? pc.slice(0, -3) : pc;
    var m = outward.match(/^([A-Z]{1,2})(\d{1,2})[A-Z]?$/);
    if (!m) return null;
    var display = pc.length >= 5 ? outward + ' ' + pc.slice(-3) : outward;
    return { area: m[1], district: Number(m[2]), display: display };
  }

  var waNumber = (dialog.dataset.waNumber || '').replace(/[^0-9]/g, '');

  // Point the contact link at WhatsApp with the postcode filled in, when a number is set.
  function setContact(postcode) {
    if (!waNumber) return;
    var message = (dialog.dataset.waMessage || '').replace(/\[postcode\]/g, postcode || '');
    contact.setAttribute('href', 'https://wa.me/' + waNumber + (message ? '?text=' + encodeURIComponent(message) : ''));
    contact.setAttribute('target', '_blank');
    contact.setAttribute('rel', 'noopener');
  }

  function show(text, showMini, showContact) {
    main.textContent = text;
    mini.textContent = showMini ? dialog.dataset.mini || '' : '';
    mini.hidden = !mini.textContent;
    contact.hidden = !showContact;
    result.hidden = false;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var pc = parse(input.value);
    if (!pc) {
      show(dialog.dataset.invalid, false, false);
      return;
    }
    var needsQuote = quote.some(function (q) {
      return q.area === pc.area && pc.district >= q.from && pc.district <= q.to;
    });
    var price = prices[pc.area];
    setContact(pc.display);
    if (needsQuote) {
      show(dialog.dataset.quote, false, true);
    } else if (price === undefined) {
      show(dialog.dataset.none, false, true);
    } else {
      var text = (dialog.dataset.result || '')
        .replace(/\[price\]/g, formatPrice(price))
        .replace(/\[postcode\]/g, pc.display);
      show(text, true, false);
    }
  });

  function open(trigger) {
    if (typeof dialog.showModal !== 'function') return false;
    lastTrigger = trigger;
    dialog.showModal();
    document.documentElement.classList.add('uvb-popup-open');
    window.setTimeout(function () { input.focus(); }, 50);
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href$="#delivery-checker"], [data-uvb-delivery-open]');
    if (!link) return;
    if (open(link)) event.preventDefault();
  });

  // Contact link: close the pop-up, then go to the contact section (scroll if it's on this page).
  contact.addEventListener('click', function (event) {
    if (/^https:\/\/wa\.me\//.test(contact.getAttribute('href') || '')) {
      dialog.close(); // WhatsApp opens in a new tab
      return;
    }
    var url;
    try { url = new URL(contact.getAttribute('href'), window.location.href); } catch (e) { return; }
    var samePage = url.origin === window.location.origin &&
      url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
    var target = samePage && url.hash ? document.getElementById(url.hash.slice(1)) : null;
    event.preventDefault();
    lastTrigger = null; // don't jump back to the link that opened the pop-up
    dialog.close();
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', url.hash);
    } else {
      window.location.href = url.href;
    }
  });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog || event.target.closest('[data-uvb-dc-close]')) dialog.close();
  });
  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('uvb-popup-open');
    if (lastTrigger) lastTrigger.focus();
  });
})();
